import React, { createRef, forwardRef, useEffect, useState } from 'react';
import HorizontalList, { HorizontalListProps } from './index';

let scrolledPos = 0;

function useHorizontalList<T>(config: HorizontalListProps<T> & { scrollWidth?: number }) {
    const ref = createRef<HTMLDivElement>();
    const [isRightScrollAvailable, setIsRightScrollAvailable] = useState(true);
    const [isLeftScrollAvailable, setIsLeftScrollAvailable] = useState(true);

    const widthToScroll = config.scrollWidth ?? 600;


    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        setIsLeftScrollAvailable(_isLeftScrollAvailable(el))
        setIsRightScrollAvailable(_isRightScrollAvailable(el))
    }, [])

    const scrollRight = () => {
        const el = ref.current;
        if (!el) return;
        scrolledPos = Math.min(scrolledPos + widthToScroll, el.scrollWidth)
        el.scrollTo({ left: scrolledPos, behavior: 'smooth' })
        setTimeout(() => {
            setIsRightScrollAvailable(_isRightScrollAvailable(el))
            setIsLeftScrollAvailable(_isLeftScrollAvailable(el))
        }, 500);
    }
    const scrollLeft = () => {
        const el = ref.current;
        if (!el) return;
        scrolledPos = Math.max(scrolledPos - widthToScroll, 0)
        el.scrollTo({ left: scrolledPos, behavior: 'smooth' })
        // if (config.itemClass)
        //     gsap.timeline()
        //         .to(`.${config.itemClass}`, { opacity: 0 })
        //         .to(`.${config.itemClass}`, { opacity: 1 })

        setTimeout(() => {
            setIsRightScrollAvailable(_isRightScrollAvailable(el))
            setIsLeftScrollAvailable(_isLeftScrollAvailable(el))
        }, 500);
    }


    const _isLeftScrollAvailable = (el: HTMLElement) => {
        return shouldAllowScroll('left', el);
    }

    const _isRightScrollAvailable = (el: HTMLElement) => {
        return shouldAllowScroll('right', el);
    }
    return {
        isRightScrollAvailable,
        isLeftScrollAvailable,
        scrollRight,
        scrollLeft,
        List: (
            <HorizontalList<T>
                {...config}
                containerRef={ref}
            />
        )

    }
}


function shouldAllowScroll(direction: 'left' | 'right', el: HTMLElement) {
    const scrollWidth = el.scrollWidth;
    const containerWidth = el.clientWidth;
    const scrolled = el.scrollLeft;
    if (direction === 'left') {
        console.log("left ? ", scrolled > 0)
        return scrolled > 0
    } else {
        console.log("right ? ", scrolled > 0)
        return containerWidth + scrolled < scrollWidth
    }
}

export default useHorizontalList;